export const RateStarPopup = (props) => {
    const { visible } = props;


    if (!visible) { return (<></>) }
    return (
        <div className="popupVoteStar" onClick={(e) => props.handleClickOutSite(e)}>
            <div className="cardPopup">
                <h3>Lý do bạn không hài lòng về câu trả lời</h3>
                <div className="bodyPopup">
                    <textarea type="text" placeholder="Vui lòng nhập nội dung" onChange={(e) => props.handleChange(e)} value={props.content}></textarea>
                    <div className="footerPopup">
                        <a className="frameBtn btnCancel" onClick={() => props.onCancel()}>Hủy</a>
                        <a className="frameBtn btnSubmit" onClick={() => props.onFinish()}>Gửi</a>
                    </div>
                </div>
            </div>
        </div>
    );
}